// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__jTLOF","buttons":"Footer_buttons__3Fkdn"};